"use client";

import { SessionProvider as NextAuthSessionProvider } from "next-auth/react";
import { SessionProvider } from "@/components/SessionProvider";
import { LoadingProvider } from "@/context/LoadingContext";
import PageLoadingScreen from "@/components/PageLoadingScreen";

export function Providers({ children }) {
  return (
    <NextAuthSessionProvider>
      <LoadingProvider>
        <PageLoadingScreen />
        <SessionProvider>
          {children}
        </SessionProvider>
      </LoadingProvider>
    </NextAuthSessionProvider>
  );
}